import {
  hapticFeedbackImpactOccurred,
  hapticFeedbackNotificationOccurred,
  hapticFeedbackSelectionChanged,
} from '@telegram-apps/sdk-react';
import { safe } from './env';

/**
 * Тактильный отклик. Вне Telegram и на клиентах без поддержки — тихо ничего.
 * Правило: impact — на действие пользователя, notification — на исход операции,
 * selection — на переключение чего-то без последствий.
 */
export const haptic = {
  tap(style: 'light' | 'medium' | 'heavy' | 'soft' | 'rigid' = 'light'): void {
    safe(() => {
      if (hapticFeedbackImpactOccurred.isAvailable()) hapticFeedbackImpactOccurred(style);
    });
  },
  result(type: 'error' | 'success' | 'warning'): void {
    safe(() => {
      if (hapticFeedbackNotificationOccurred.isAvailable()) hapticFeedbackNotificationOccurred(type);
    });
  },
  select(): void {
    safe(() => {
      if (hapticFeedbackSelectionChanged.isAvailable()) hapticFeedbackSelectionChanged();
    });
  },
};
